"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vsrDepositInstruction = void 0;
const solana_spl_token_modern_1 = require("solana-spl-token-modern");
const VsrClient_1 = require("./vsr-client/VsrClient");
const bn_js_1 = __importDefault(require("bn.js"));
/**
 * Generate instruction of Voter Stake Registry (VSR) SPL Governance plugin to deposit to an entry slot (index).
 * This function loads data from blockchain when not all parameters are provided.
 *
 * @type {Object} args - Arguments on instruction creation
 * @param param {VoterStakeRegistryProgram} args.program - anchor program instance ov Voter Stake Registry
 * @param param {number} args.depositEntryIndex - entry index to deposit to
 * @param param {number|BN} args.depositAmount - amount to deposit
 * @param param {PublicKey} args.registrarAddress - VSR registrar address account (default: MNDE_VSR_REGISTRAR_ADDRESS)
 * @param param {PublicKey} args.depositAuthority - deposit authority [SIGNER] (default: provider wallet address)
 * @param param {PublicKey} args.depositTokenAccount - token account to process deposit from to VSR vault (default: ATA of depositAuthority)
 * @param param {PublicKey} args.depositTokenMint - token mint of deposit token account, used to calculate voter vault address when not specified (default: MNDE_MINT)
 * @type {Object} return - Return data of generated instruction
 * @return {TransactionInstruction} return.instruction - Instruction to close treasury
 */
async function vsrDepositInstruction({ program, depositEntryIndex, depositAmount, registrarAddress = VsrClient_1.MNDE_VSR_REGISTRAR_ADDRESS, voterAccount, depositTokenAccount, depositAuthority = program.provider.publicKey, vsrVoterVault, depositTokenMint = VsrClient_1.MNDE_MINT, }) {
    if (!depositTokenAccount && depositTokenMint) {
        depositTokenAccount = (0, solana_spl_token_modern_1.getAssociatedTokenAddressSync)(depositTokenMint, depositAuthority, true);
    }
    if (!depositTokenAccount) {
        throw new Error('depositTokenAccount or depositTokenMint is required to create VSR deposit instruction');
    }
    if (!vsrVoterVault) {
        if (!depositTokenMint && depositTokenAccount) {
            const tokenAccount = await (0, solana_spl_token_modern_1.getAccount)(program.provider.connection, depositTokenAccount);
            depositTokenMint = tokenAccount.mint;
        }
        if (!depositTokenMint) {
            throw new Error('vsrVoterVault address or depositTokenMint (to calculate the vault address from) is required to create VSR deposit instruction');
        }
        vsrVoterVault = (0, VsrClient_1.vaultAddress)({
            voter: voterAccount,
            mint: depositTokenMint,
        });
    }
    const instruction = await program.methods
        .deposit(depositEntryIndex, new bn_js_1.default(depositAmount))
        .accounts({
        registrar: registrarAddress,
        voter: voterAccount,
        vault: vsrVoterVault,
        depositToken: depositTokenAccount,
        depositAuthority,
        tokenProgram: solana_spl_token_modern_1.TOKEN_PROGRAM_ID,
    })
        .instruction();
    return { instruction };
}
exports.vsrDepositInstruction = vsrDepositInstruction;
//# sourceMappingURL=vsrDepositInstruction.js.map